module.exports = __webpack_public_path__ + "img/filter.bff9bbe6.svg";